<template>
	<div class="right">
		<div>
			 <environment></environment>
			 <monitor></monitor>
			 <equipment></equipment>
		</div>
	</div>
</template>

<script>
	import environment from './rightchild/environment.vue'
	import monitor from './rightchild/monitor.vue'
	import equipment from './rightchild/equipment.vue'
	export default {
	  name: "",
	  components: {
		  environment,
		  monitor,
		  equipment
	  },
	  methods: {
	   
	  },
	  mounted() {
	     
	  }
	};
</script>

<style scoped="scoped">
	.right{
		position: absolute;
		top: 0;
		z-index: 1;
		right: 0;
		width: 22vw;
		height: 100vh;
		background: url(../../assets/img/right.png) no-repeat;
		background-size: 100% 100%; 
	}
	.right>div{
		position: absolute;
		top: 9.8vh;
		width: 100%;
		height: 89.6vh;
		right: 0;
		/* background: url(../../assets/img/rightchild.png) no-repeat; */
		background-size: 100% 100%;
		box-sizing: border-box;
		padding: 3% 12px 3% 16px;
	}
</style>
